export enum ChannelType {
  UnSpecified = 'UnSpecified',
  URL = 'Url',
  CUSTOM = 'Custom',
}